import Button from '../Button/Button';

const IconButton = ({ icon, onClick, disabled, variant = 'default', className = '', ...props }) => (
  <Button
    variant="icon"
    subtleDanger={variant === 'danger'}
    onClick={onClick}
    disabled={disabled}
    className={className}
    {...props}
  >
    <span className="material-symbols-outlined">{icon}</span>
  </Button>
);

export default IconButton;
